exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar {\n  -webkit-box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.38);\n          box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.38);\n  background-color: #2275c3;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: row;\n          flex-direction: row;\n  left: 0;\n  min-height: 56px;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 100; }\n  .navbar .hide-sm {\n    display: block; }\n  @media (max-width: 790px) {\n      .navbar .hide-sm {\n        display: none; } }\n  .navbar .menu-button {\n    cursor: pointer;\n    display: none;\n    padding: 8px 0; }\n  @media (max-width: 790px) {\n      .navbar .menu-button {\n        display: block; } }\n  .navbar .menu-button i {\n      color: #fff;\n      padding: 16px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/navbar/navbar.component.scss
// module id = ../../../../../src/app/navbar/navbar.component.scss
// module chunks = main